/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type RecipientEmailStatus =
    (typeof RecipientEmailStatus)[keyof typeof RecipientEmailStatus];

export const RecipientEmailStatus = {
    NotRequired: 0,
    Queued: 1,
    NotQueued: 2,
    Uncertain: 3,
} as const;
